module.exports = __webpack_public_path__ + "static/img/信息框@2x.8d407ae3.png";